<template>
  <div>
    <div class="pop_wrap" v-if="shadeNum > 0">
      <div class="pop_div">
        <div class="pop">
          <main>
            <div class="loader">
              <div class="loader-inner pacman">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>

    <div id="app">
      <v-headinfo v-if="isLogin"></v-headinfo>
      <v-leftmenu v-if="isLogin"></v-leftmenu>
      <!--<keep-alive>-->
      <div id="container">
        <!--<router-view class="container"></router-view>-->
        <keep-alive >
          <router-view class="container" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view class="container" v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <!--</keep-alive>-->
    </div>

    <dialogImageAddTag></dialogImageAddTag>
    <dialogOrderImg></dialogOrderImg>
  </div>
</template>

<script type="text/javascript" src="https://image.uzhujf.com/thirdparty/js/store.min.js"></script>
<script>
  import vLeftmenu from '../src/components/base/leftMenu.vue'
  import vHeadinfo from '../src/components/base/headInfo.vue'
  import cookie from '../src/assets/js/cookie.js'
  import bus from '../src/assets/js/bus.js'
  import dialogImageAddTag from "../src/components/dialog/dialogImageAddTag.vue"
  import dialogOrderImg from "../src/components/dialog/dialogOrderImg.vue"
  import { mapState,mapGetters,mapMutations,mapActions } from 'vuex'

  export default {
    data(){
      return{
      }
    },
    components: {
      'v-leftmenu':vLeftmenu,
      'v-headinfo':vHeadinfo,
      dialogImageAddTag:dialogImageAddTag,
      dialogOrderImg:dialogOrderImg
    },
    created(){
      var that = this;
    },
    computed: mapGetters({
      isLogin:"isLogin",
      shadeNum:"shadeNum"
    }),
    methods: mapActions({
    })
  }
</script>

<style lang="scss" scoped>
  @import "../src/assets/css/layout/variable.scss";

.pop_wrap{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 99999;
}
.pop_div{
  width:100%;
  height:100%;
  background: #000000;
  filter:alpha(opacity=60);
  -moz-opacity:0.6;
  -khtml-opacity: 0.6;
  opacity: 0.6;
}
.pop_wrap .pop{
  position: absolute;
  width: 200px;
  height: 30px;
  left: 50%;
  top: 50%;
  margin-left: -100px;
  margin-top: -15px;
}

main {
  width: 95%;
  max-width: 1000px;
}

main.loaded {
  transition: opacity .25s linear;
  opacity: 1;
}

main header {
  width: 100%;
}

main header > div {
  width: 50%;
}

main header > .left,
main header > .right {
  height: 100%;
}

main .loaders {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
}

main .loaders .loader {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 25%;
  max-width: 25%;
  height: 200px;
  align-items: center;
  justify-content: center;
}

@-webkit-keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  50% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
}

@keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  50% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
}

@-webkit-keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90ldeg);
  }
  50% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@-webkit-keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}

@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}

.pacman {
  position: relative;
}

.pacman > div:nth-child(2) {
  -webkit-animation: pacman-balls 1s 0s infinite linear;
  animation: pacman-balls 1s 0s infinite linear;
}

.pacman > div:nth-child(3) {
  -webkit-animation: pacman-balls 1s 0.33s infinite linear;
  animation: pacman-balls 1s 0.33s infinite linear;
}

.pacman > div:nth-child(4) {
  -webkit-animation: pacman-balls 1s 0.66s infinite linear;
  animation: pacman-balls 1s 0.66s infinite linear;
}

.pacman > div:nth-child(5) {
  -webkit-animation: pacman-balls 1s 0.99s infinite linear;
  animation: pacman-balls 1s 0.99s infinite linear;
}

.pacman > div:first-of-type {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #fff;
  border-left: 25px solid #fff;
  border-bottom: 25px solid #fff;
  border-radius: 25px;
  -webkit-animation: rotate_pacman_half_up 0.5s 0s infinite;
  animation: rotate_pacman_half_up 0.5s 0s infinite;
}

.pacman > div:nth-child(2) {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #fff;
  border-left: 25px solid #fff;
  border-bottom: 25px solid #fff;
  border-radius: 25px;
  -webkit-animation: rotate_pacman_half_down 0.5s 0s infinite;
  animation: rotate_pacman_half_down 0.5s 0s infinite;
  margin-top: -50px;
}

.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  background-color: #fff;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  width: 10px;
  height: 10px;
  position: absolute;
  -webkit-transform: translate(0, -6.25px);
  -ms-transform: translate(0, -6.25px);
  transform: translate(0, -6.25px);
  top: 25px;
  left: 100px;
}
</style>



// WEBPACK FOOTER //
// App.vue?1657ced2